<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>工单详情</span>
            <div>
              <el-button type="primary" size="small" @click="_goBack()">
                <i class="el-icon-close"></i> 返回
              </el-button>
            </div>
          </div>
          <div class="card-content text-left">
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="form-item">
                  <label class="form-label">工单编码：</label>
                  <span>{{ housekeepingServDetailInfo.cartId ==
                    '-1' ? housekeepingServDetailInfo.poolId :housekeepingServDetailInfo.cartId}}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="form-item">
                  <label class="form-label">服务名称：</label>
                  <span>{{ housekeepingServDetailInfo.servName }}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="form-item">
                  <label class="form-label">申请人：</label>
                  <span>{{ housekeepingServDetailInfo.applyName }}</span>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="8">
                <div class="form-item">
                  <label class="form-label">联系方式：</label>
                  <span>{{ housekeepingServDetailInfo.applyTel }}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="form-item">
                  <label class="form-label">服务类型：</label>
                  <span>{{ housekeepingServDetailInfo.hktName }}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="form-item">
                  <label class="form-label">预约时间：</label>
                  <span>{{ housekeepingServDetailInfo.appointmentTime }}</span>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="8">
                <div class="form-item">
                  <label class="form-label">状态：</label>
                  <span>{{ housekeepingServDetailInfo.stateName }}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="form-item">
                  <label class="form-label">备注：</label>
                  <span>{{ housekeepingServDetailInfo.context }}</span>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20" v-if="housekeepingServDetailInfo.visitType">
              <el-col :span="8">
                <div class="form-item">
                  <label class="form-label">回访满意度：</label>
                  <span>{{ housekeepingServDetailInfo.visitType == '1001' ? '满意' : '不满意' }}</span>
                </div>
              </el-col>
              <el-col :span="16">
                <div class="form-item">
                  <label class="form-label">回访内容：</label>
                  <span>{{ housekeepingServDetailInfo.visitContext }}</span>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row v-if="housekeepingServDetailInfo.beforePhotos.length > 0">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>维修前图片</span>
          </div>
          <div class="card-content">
            <el-row :gutter="20">
              <el-col :span="4" v-for="(item, index) in housekeepingServDetailInfo.beforePhotos" :key="index">
                <div class="image-item">
                  <img :src="item.url" @click="openFile(item)" class="preview-image" />
                </div>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row v-if="housekeepingServDetailInfo.afterPhotos.length > 0">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>维修后图片</span>
          </div>
          <div class="card-content">
            <el-row :gutter="20">
              <el-col :span="4" v-for="(item, index) in housekeepingServDetailInfo.afterPhotos" :key="index">
                <div class="image-item">
                  <img :src="item.url" @click="openFile(item)" class="preview-image" />
                </div>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row
      v-if="housekeepingServDetailInfo.maintenanceType == '1001' || housekeepingServDetailInfo.maintenanceType == '1003'">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>相关物品</span>
          </div>
          <div class="card-content">
            <el-table :data="housekeepingServDetailInfo.resourceStoreInfo" border style="width: 100%">
              <el-table-column prop="resId" label="物品资源编号" align="center"></el-table-column>
              <el-table-column prop="rstName" label="物品资源类型" align="center">
                <template slot-scope="scope">
                  {{ scope.row.rstName || '-' }}
                </template>
              </el-table-column>
              <el-table-column prop="resourceStoreName" label="物品资源名称" align="center"></el-table-column>
              <el-table-column prop="specName" label="物品资源规格" align="center">
                <template slot-scope="scope">
                  {{ scope.row.specName || '-' }}
                </template>
              </el-table-column>
              <el-table-column prop="quantity" label="物品使用数量" align="center"></el-table-column>
              <el-table-column prop="unitPrice" label="物品价格" align="center">
                <template slot-scope="scope">
                  {{ scope.row.unitPrice || '-' }}
                </template>
              </el-table-column>
              <el-table-column prop="createUserName" label="使用人" align="center"></el-table-column>
              <el-table-column prop="createTime" label="时间" align="center"></el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>工单流转</span>
          </div>
          <div class="card-content">
            <el-table :data="housekeepingServDetailInfo.housekeepingServUsers" border style="width: 100%">
              <el-table-column label="序号" align="center" width="80">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column prop="staffName" label="处理人" align="center"></el-table-column>
              <el-table-column prop="stateName" label="状态" align="center"></el-table-column>
              <el-table-column prop="endTime" label="处理时间" align="center"></el-table-column>
              <el-table-column prop="duration" label="耗时" align="center"></el-table-column>
              <el-table-column prop="context" label="意见" align="center"></el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <view-image ref="viewImage"></view-image>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { queryHousekeepingServPool, queryHouseServPoolUser } from '@/api/housekeeping/housekeepingServDetailApi'
import ViewImage from '@/components/common/viewImage'

export default {
  name: 'HousekeepingServDetail',
  components: {
    ViewImage
  },
  data() {
    return {
      housekeepingServDetailInfo: {
        poolId: '',
        cartId: '',
        servName: '',
        applyName: '',
        applyTel: '',
        hktName: '',
        roomName: '',
        appointmentTime: '',
        context: '',
        stateName: '',
        userId: '',
        userName: '',
        housekeepingServUsers: [],
        photos: [],
        housekeepingServPhotos: [],
        beforePhotos: [],
        afterPhotos: [],
        visitType: '',
        visitContext: '',
        maintenanceType: '',
        housekeepingServMaterials: '',
        housekeepingServFee: '',
        resourceStoreInfo: []
      }
    }
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      const poolId = this.$route.query.poolId
      if (!poolId) {
        return
      }
      this.housekeepingServDetailInfo.poolId = poolId
      this._listRepairPools()
    },
    async _listRepairPools() {
      try {
        const param = {
          page: 1,
          row: 1,
          shopId: getShopId(),
          poolId: this.housekeepingServDetailInfo.poolId
        }
        const res = await queryHousekeepingServPool(param)
        const data = res.data
        if (data.length < 1) {
          return
        }
        Object.assign(this.housekeepingServDetailInfo, data[0])
        this.housekeepingServDetailInfo.hktName = data[0].housekeepingServDtos[0].hktName
        this._loadRepairUser()
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    async _loadRepairUser() {
      try {
        const param = {
          page: 1,
          row: 100,
          shopId: getShopId(),
          poolId: this.housekeepingServDetailInfo.poolId
        }
        const res = await queryHouseServPoolUser(param)
        this.housekeepingServDetailInfo.housekeepingServUsers = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _goBack() {
      this.$router.go(-1)
    },
    openFile(photo) {
      this.$refs.viewImage.open(photo.url)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

.card-content {
  padding: 20px;
}

.form-item {
  margin-bottom: 18px;
}

.form-label {
  margin-right: 10px;
}

.preview-image {
  width: 120px;
  height: 120px;
  cursor: pointer;
}

.image-item {
  margin-bottom: 10px;
}
</style>